import { render, staticRenderFns } from "./housekeepingSjServList.vue?vue&type=template&id=a9dc15d4&scoped=true"
import script from "./housekeepingSjServList.vue?vue&type=script&lang=js"
export * from "./housekeepingSjServList.vue?vue&type=script&lang=js"
import style0 from "./housekeepingSjServList.vue?vue&type=style&index=0&id=a9dc15d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dc15d4",
  null
  
)

export default component.exports